<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 100%"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSchedule">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />{{ titleItem }}
        </v-btn>
      </v-col>
      <v-card class="card_container mx-auto primary">
        <v-card-title class="d-flex justify-space-between">
          <div class="filter-search-container mx-3 pa-0">
            <v-menu v-model="menuOpen" offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small class="mx-1" v-bind="attrs" v-on="on">
                  <v-icon color="#39537a">mdi-filter-variant</v-icon>
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="option in filterOptions"
                  :key="option.value"
                  @click="selectFilter(option.value)"
                >
                  <v-list-item-title>{{ option.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <v-text-field
              dense
              solo
              flat
              v-model="search"
              append-icon="mdi-magnify"
              :placeholder="searchPlaceholder"
              single-line
              hide-details
              class="search"
              @click="menuOpen = true"
              @keyup.enter="applyFilter"
              @click:append="applyFilter"
            />

            <!-- Botón para resetear filtro -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  @click="resetFilter"
                  class="reset-btn mx-1"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <span>{{ $tc("gestionEmpleados.resetFilter") }}</span>
            </v-tooltip>
          </div>

          <v-col cols="auto" class="my-n4 pr-0">
            <v-row class="ma-0 pa-0">
              <!-- Título -->
              <h3 class="secondary--text mr-4 my-auto" v-show="title">
                {{ title }}
              </h3>
              <v-row class="justify-start border ma-0">
                <!-- Botón de Refresh -->
                <v-col cols="auto pa-0">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="refreshItems"
                        class="btn-table ma-1"
                        small
                      >
                        <v-icon
                          :class="{ loader: loading4 }"
                          :loading="loading4"
                          :disabled="loading4"
                          id="icon-add"
                          class="mx-auto"
                          size="19"
                        >
                          fas fa-sync-alt
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $tc("commons.refresh") }}</span>
                  </v-tooltip>
                </v-col>

                <!-- Botón de Añadir -->
                <v-col cols="auto pa-0">
                  <div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="white"
                          dark
                          icon
                          class="btn-table ma-1"
                          small
                        >
                          <v-icon
                            size="20"
                            class="mx-auto"
                            id="icon-add"
                            v-bind="attrs"
                            v-on="on"
                            @click="openAdd"
                          >
                            fas fa-plus
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $tc("commons.add") }}</span>
                    </v-tooltip>
                  </div>
                </v-col>
              </v-row>
            </v-row>
          </v-col>
        </v-card-title>
        <v-divider class="mt-1"></v-divider>
        <v-data-table
          :headers="headers"
          :items="paginatedItems"
          :single-expand="true"
          :expanded.sync="expanded"
          :title="title"
          item-key="name"
          show-expand
          class="mx-auto"
          @item-expanded="onExpand"
          fixed-header
          :height="calculateMaxHeight"
          @refreshItems="refreshItems"
          :hide-default-footer="true"
          disable-pagination
        >
          <!-- Fila expandida -->
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers?.length" style="padding: 0px">
              <v-simple-table style="width: 100%">
                <thead>
                  <tr>
                    <th class="th__title">{{ $tc("schedules.instance") }}</th>
                    <th class="th__title">{{ $tc("schedules.fecDesde") }}</th>
                    <th class="th__title">{{ $tc("schedules.fecHasta") }}</th>
                    <th class="th__title">{{ $tc("schedules.segmDespl") }}</th>
                    <th class="th__title">
                      {{ $tc("schedules.numSecuencia") }}
                    </th>
                    <th class="th__title">{{ $tc("schedules.actions") }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(inst, index) in instancias" :key="index">
                    <td>{{ inst.segmNombre }}</td>
                    <td>{{ inst.fecDesde }}</td>
                    <td>{{ inst.fecHasta }}</td>
                    <td>{{ inst.segmDespl }}</td>
                    <td>{{ inst.numSecuencia }}</td>
                    <td>
                      <div
                        width="100px"
                        style="
                          width: 50px;
                          display: flex;
                          justify-content: space-between;
                        "
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-icon id="icon-edit" @click="openEdit(inst)"
                                >fas fa-pen</v-icon
                              >
                            </span>
                          </template>
                          <span>{{ $tc("editRegistrations.edit") }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <v-icon id="icon-delete" @click="showDelete(inst)"
                                >fas fa-trash</v-icon
                              >
                            </span>
                          </template>
                          <span>{{ $tc("editRegistrations.delete") }}</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <v-row class="ma-0 pa-0" justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-pagination
            v-if="employees?.length > 0"
            class="paginado ma-0 pa-0"
            v-model="currentPage"
            :length="totalPages"
            prev-icon="mdi-chevron-left"
            next-icon="mdi-chevron-right"
            hide-delimiter-background
            :items-per-page="limit"
            @input="changePage"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-dialog
      v-model="openEmployee"
      max-width="600px"
      persistent
      @keydown.esc="cancel"
    >
      <v-card max-width="600px">
        <v-card-title
          style="display: flex; justify-content: center"
          class="mb-5"
        >
          <p class="small my-auto">{{ mode }}</p>
        </v-card-title>
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mr-1 ml-1"
        >
          {{ alertValidate }}</v-alert
        >
        <v-form
          @submit.prevent="validation"
          class="ml-5 mr-5"
          ref="form"
          v-model="valid"
        >
          <date-with-check :showCheck="true" class="mb-4" />
          <v-select
            required
            :rules="rules"
            label="Segmento"
            dense
            outlined
            class=""
            v-model="data.segment"
            :items="segment"
            item-value="segmId"
            item-text="segment"
            @change="changeSegment"
          />
          <v-text-field
            class=""
            :label="$tc('changeSchedule.sequenceNumber')"
            dense
            outlined
            v-model="data.sequenceNumber"
            disabled
          />

          <v-text-field
            v-model="data.initialDay"
            :label="$tc('changeSchedule.initialDay')"
            outlined
            dense
            type="number"
            :max="initialDay"
            :min="1"
            :disabled="changeSeg"
            :rules="rulesDays"
          />
          <v-alert
            v-if="showLimitAlert"
            type="warning"
            dense
            outlined
            @input="showLimitAlert = false"
          >
            {{ $tc("gestionEmpleados.OnlyUpTo300Employees") }}
          </v-alert>
          <v-autocomplete
            :rules="rules"
            :label="$tc('schedules.employees')"
            outlined
            v-model="data.employees"
            :items="employeesWithSelectAll"
            multiple
            item-value="empId"
            item-text="fullName"
            :filter="customFilter"
            :search-input.sync="searchEmployee"
            v-if="typeForm == 'add'"
          >
            <template v-slot:item="{ item }">
              <v-list-item @click.stop="toggleItem(item)">
                <v-list-item-action>
                  <v-checkbox
                    :input-value="isSelected(item)"
                    :indeterminate="isIndeterminate(item)"
                    dense
                    hide-details
                    readonly
                  />
                </v-list-item-action>
                <v-list-item-content class="ml-n3">
                  <v-list-item-title>{{
                    item.empId === "all"
                      ? item.fullName
                      : item.fullName + " (" + item.file + ")"
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 2">
                <span>{{
                  item.empId === "all"
                    ? item.fullName
                    : item.fullName + " (" + item.file + ")"
                }}</span>
              </v-chip>
              <span v-if="index === 2" class="grey--text text-caption">
                (+ {{ data.employees.length - 2 }} )
              </span>
            </template>
          </v-autocomplete>
          <div class="d-flex justify-space-between pb-4">
            <v-btn class="bt-exit" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn type="submit" class="bt-acept">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <Loader :loading="isLoading" />
    </v-dialog>
  </v-row>
</template>

<script>
import schedules from "@/store/horarios/schedules";
import employeesSchedules from "@/store/horarios/employees";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import date from "@/store/common/date";
import Loader from "@/components/Complement/Loader.vue";
import moment from "moment";

export default {
  components: {
    DateWithCheck,
    TableWithSearch,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },

  data() {
    return {
      expanded: [],
      search: "",
      menuOpen: false,
      filterType: "nombre",
      filterOptions: [
        { text: "Nombre", value: "nombre" },
        { text: "Legajo", value: "legajo" },
      ],
      title: this.$tc("schedules.employees"),
      color: "",
      titleDelete: "esta instancia?",
      isLoading: false,
      headers: [
        {
          text: "Nombre",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Legajo",
          value: "file",
          class: "primary secondary--text",
          visible: true,
        },
      ],
      maxWidth: "600px",
      valid: true,
      typeForm: "",
      itemToDelete: null,
      alert: false,
      textAlert: "",
      data: {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        employees: [],
      },
      error: false,
      alertValidate: "",
      initialDay: null,
      changeSeg: true,
      itemEdit: null,
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      rulesDays: [
        (v) =>
          (v !== null && v !== undefined && v !== "" && this.validateDays(v)) ||
          `El número está fuera del rango. El rango válido es de 1 a ${this.initialDay}`,
      ],
      loading4: false,
      instancias: [],
      employeedSelected: null,
      currentPage: 1,
      limit: 20,
      searchEmployee: "",
      maxEmployees: 300,
      showLimitAlert: false,
      order: "apellido",
    };
  },

  computed: {
    searchPlaceholder() {
      const selected = this.filterOptions.find(
        (f) => f.value === this.filterType,
      );
      return selected
        ? `Buscar por ${selected.text.toLowerCase()}...`
        : "Selecciona un filtro";
    },
    employeesWithSelectAll() {
      return [
        { empId: "all", fullName: "Seleccionar todos", file: "" },
        ...this.getAllEmployees,
      ];
    },
    calculateMaxHeight() {
      switch (true) {
        case this.employees?.length > 7:
          return "60vh";
      }
    },
    employees() {
      return employeesSchedules.state.employees;
    },
    getAllEmployees() {
      return this.$store.state.employees.employees;
    },
    padding() {
      return schedules.state.paddingNav;
    },
    openEmployee: {
      get() {
        return employeesSchedules.state.openEmployee;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    mode: {
      get() {
        return employeesSchedules.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openDelete: {
      get() {
        return employeesSchedules.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    segment() {
      return this.$store.state.changeSchedule.segment;
    },
    validInitialDay() {
      return this.initialDay !== null;
    },
    totalPages() {
      return Math.ceil(this.employees.length / this.limit);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.limit;
      const end = start + this.limit;
      return this.employees.slice(start, end);
    },
    titleItem() {
      const schedule = schedules.state.schedules.find(
        (schedule) => schedule.id === schedules.state.scheduleId,
      );
      return schedule ? schedule.name : "Horario";
    },
  },

  methods: {
    selectFilter(type) {
      this.filterType = type;
      this.search = "";
      this.menuOpen = false;
    },

    isSelected(item) {
      if (item.empId === "all") {
        return this.data.employees.length === this.getAllEmployees.length;
      }

      return this.data.employees.includes(item.empId);
    },

    isIndeterminate(item) {
      if (item.empId !== "all") return false;

      return (
        this.data.employees.length > 0 &&
        this.data.employees.length < this.getAllEmployees.length
      );
    },

    toggleItem(item) {
      if (item.empId === "all") {
        const isAllSelected = this.data.employees.length > 0;

        if (isAllSelected) {
          this.data.employees = [];
          this.showLimitAlert = false;
        } else {
          const allIds = this.getAllEmployees.map((e) => e.empId);

          if (allIds.length > this.maxEmployees) {
            this.data.employees = allIds.slice(0, this.maxEmployees);
            this.showLimitAlert = true;
          } else {
            this.data.employees = allIds;
            this.showLimitAlert = false;
          }
        }

        this.searchEmployee = "";
        return;
      }

      const exists = this.data.employees.includes(item.empId);

      if (exists) {
        this.data.employees = this.data.employees.filter(
          (id) => id !== item.empId,
        );
        this.showLimitAlert = false;
      } else {
        if (this.data.employees.length >= this.maxEmployees) {
          this.showLimitAlert = true;
          return;
        }

        this.data.employees = [...this.data.employees, item.empId];

        if (this.data.employees.length === this.maxEmployees) {
          this.showLimitAlert = true;
        } else {
          this.showLimitAlert = false;
        }
      }

      this.searchEmployee = "";
    },

    customFilter(item, queryText) {
      const search = queryText.toLowerCase();

      return (
        item.fullName?.toLowerCase().includes(search) ||
        item.file?.toString().toLowerCase().includes(search)
      );
    },

    async resetFilter() {
      this.search = "";
      this.isLoading = true;
      await employeesSchedules.dispatch("getEmployees");
      this.isLoading = false;
    },

    async applyFilter() {
      if (!this.search) return;

      this.isLoading = true;
      const filterPayload = {
        [this.filterType]: this.search,
      };
      await employeesSchedules.dispatch("getEmployees", filterPayload);
      this.isLoading = false;
    },

    changePage(page) {
      this.currentPage = page;
    },

    showDelete(item) {
      employeesSchedules.commit("setOpenDelete", true);
      this.itemToDelete = {
        id: item.id,
        schedule: schedules.state.scheduleId,
        from: moment.utc(item.fecDesde, "DD-MM-YYYY").format("YYYY-MM-DD"),
      };
    },

    async openEdit(item) {
      this.alert = false;
      this.typeForm = "edit";
      employeesSchedules.commit("setMode", this.$tc("schedules.editEmployee"));
      this.$store.commit(
        "changeSchedule/setScheduleId",
        schedules.state.scheduleId,
      );
      employeesSchedules.commit(
        "setScheduleId",
        employeesSchedules.state.scheduleId,
      );
      this.$store.dispatch("employees/getEmployees", {
        photo: false,
        order: this.order,
        soloActivos: true,
      });

      await this.$store.dispatch("changeSchedule/getSegment").then(() => {
        this.data = {
          segment: item.segmId,
          initialDay: item.segmDespl,
          sequenceNumber: item.numSecuencia,
          oldFecDesde: moment
            .utc(item.fecDesde, "DD-MM-YYYY")
            .format("YYYY-MM-DD"),
        };
        this.itemEdit = {
          id: item.id,
          name: item.name,
        };
      });
      date.state.dateFrom = moment
        .utc(item.fecDesde, "DD-MM-YYYY")
        .format("YYYY-MM-DD");

      date.state.dateTo = !item.fecHasta
        ? null
        : moment.utc(item.fecDesde, "DD-MM-YYYY").format("YYYY-MM-DD");

      date.state.checkTo = !item.fecHasta ? true : false;
      employeesSchedules.commit("setOpenEmployee", true);
    },

    openAdd() {
      this.alert = false;
      this.typeForm = "add";
      employeesSchedules.commit("setMode", this.$tc("schedules.addEmployee"));
      this.$store.commit(
        "changeSchedule/setScheduleId",
        schedules.state.scheduleId,
      );
      employeesSchedules.commit(
        "setScheduleId",
        employeesSchedules.state.scheduleId,
      );
      this.$store.dispatch("changeSchedule/getSegment").then(() => {
        if (this.$store.state.changeSchedule.segment.length == 0) {
          this.alert = true;
          this.textAlert = this.$tc("schedules.noSegmentAlert");
          this.color = "#FF8D58";
        } else {
          this.$store
            .dispatch("employees/getEmployees", {
              photo: false,
              order: this.order,
              soloActivos: true,
            })
            .then(() => {
              this.isLoading = false;
              employeesSchedules.commit("setOpenEmployee", true);
            });
        }
      });
    },

    formatEmployeeInstances(employee) {
      return employee.instans.map((employeed) => {
        return {
          fecDesde: moment.utc(employeed.fecDesde).format("DD-MM-YYYY"),
          fecHasta: employeed.fecHasta
            ? moment.utc(employeed.fecHasta).format("DD-MM-YYYY")
            : "",
          segmNombre: employeed.segmNombre,
          segmDespl: employeed.segmDespl,
          numSecuencia: employeed.numSecuencia,
          segmId: employeed.segmId,
          id: employee.id,
        };
      });
    },

    onExpand({ item, value }) {
      if (!value) {
        this.isLoading = false;
      } else {
        this.isLoading = true;
        this.employeedSelected = item;
        this.instancias = this.formatEmployeeInstances(item);
        this.isLoading = false;
      }
    },

    async refreshItems() {
      this.loading4 = true;
      try {
        await employeesSchedules.dispatch("getEmployees");
      } finally {
        setTimeout(() => {
          this.loading4 = false;
        }, 2000);
      }
    },

    saveForm() {
      switch (this.typeForm) {
        case "add":
          this.addEmployees();
          break;
        case "edit":
          this.editEmployee();
          break;
        default:
          break;
      }
    },

    validation() {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.saveForm();
      } else {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);

        this.alertValidate = this.$tc("editRegistrations.required");
      }
    },

    initialDays(selectedData) {
      let inicialDay = this.$store.state.changeSchedule.segment.filter(
        (option) => {
          return option.segmId == selectedData;
        },
      );
      return inicialDay[0]?.days;
    },

    changeSegment() {
      this.changeSeg = false;

      this.$store.commit("changeSchedule/setSegmId", this.data.segment);
      this.$store.dispatch("changeSchedule/getSequence").then(() => {
        this.data.sequenceNumber =
          this.$store.state.changeSchedule.numsequence[0].id;
        this.initialDay = this.initialDays(this.data.segment);
      });
    },

    validateDays(value) {
      if (!this.validInitialDay) {
        return true;
      }
      return value >= 1 && value <= this.initialDay;
    },

    goToSchedule() {
      schedules.dispatch("handleShowWindow", "schedule");
    },

    cancel() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.$refs.form.resetValidation();
      this.showLimitAlert = false;
      (this.data = {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        employees: [],
      }),
        (this.error = false);
      employeesSchedules.commit("setOpenEmployee", false);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    selectedEmployeesNames() {
      const names = this.$store.state.employees.employees
        .filter((item) => this.data.employees.includes(item.empId))
        .map((item) => item.fullName);

      return names;
    },

    addEmployees() {
      const payload = {
        segment: this.data.segment,
        initialDay: this.data.initialDay,
        sequenceNumber: this.data.sequenceNumber,
        employees: this.data.employees,
        from: date.state.dateFrom,
        to: date.state.dateTo,
        schedule: schedules.state.scheduleId,
        names: this.selectedEmployeesNames(),
      };

      employeesSchedules.commit("setNew", payload);
      employeesSchedules
        .dispatch("new")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.addEmployeesSuccess");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancel();
    },

    editEmployee() {
      let nameSegment = this.$store.state.changeSchedule.segment.find(
        (segment) => this.data.segment === segment.segmId,
      );

      const payload = {
        segment: this.data.segment,
        initialDay: this.data.initialDay,
        sequenceNumber: this.data.sequenceNumber,
        from: date.state.dateFrom,
        to: date.state.checkTo == true ? null : date.state.dateTo,
        schedule: schedules.state.scheduleId,
        id: this.itemEdit.id,
        oldFrom: this.data.oldFecDesde,
        segmNombre: nameSegment.segment,
      };
      employeesSchedules.commit("setEdit", payload);
      employeesSchedules
        .dispatch("edit")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.editEmployeesSuccess");
          this.color = "#82A1D0";

          this.instancias = this.formatEmployeeInstances(
            employeesSchedules.state.employees.find(
              (emp) => this.itemEdit.id === emp.id,
            ),
          );
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancel();
    },

    deleteItem() {
      employeesSchedules.commit("setDeleteItem", this.itemToDelete);
      employeesSchedules
        .dispatch("delete")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.deleteEmployeesSuccess");
          this.color = "#82A1D0";

          this.instancias = this.formatEmployeeInstances(
            this.employeedSelected,
          );
        })
        .catch((e) => {
          console.log(e);
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancelDelete();
    },

    cancelDelete() {
      employeesSchedules.commit("setOpenDelete", false);
    },
  },
};
</script>

<style scoped>
.filter-search-container {
  display: flex;
  align-items: center;
  border-radius: 20px;
  background-color: #a5b9d7;
  padding: 2px 4px;
}

.border {
  background-color: #1f324a2f;
  border-color: #a5b9d7;
  border-width: 5px;
  border-style: solid;
  border-radius: 25px;
}

.btn-table {
  background-color: #82a1d0;
}

.loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}

.th__title {
  background-color: #7692bc !important;
  color: white !important;
}

::v-deep .v-data-table-header th {
  background-color: #82a1d0 !important;
}

#icon-add {
  color: #ffffff;
  margin-right: 8px;
}

#icon-edit {
  color: #39537a;
  font-size: 20px;
}

#icon-delete {
  color: #e2504c;
  font-size: 20px;
}

.search {
  max-width: 500px !important;  
}

::v-deep .v-data-table--fixed-header > .v-data-table__wrapper {
  overflow-y: scroll;
  scrollbar-width: unset;
}
</style>
